import { render, staticRenderFns } from "./AddStep3.vue?vue&type=template&id=54cec970&scoped=true&"
import script from "./AddStep3.vue?vue&type=script&lang=js&"
export * from "./AddStep3.vue?vue&type=script&lang=js&"
import style0 from "./AddStep3.vue?vue&type=style&index=0&id=54cec970&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cec970",
  null
  
)

export default component.exports